@use "~theme/breakpoints";
@use "~theme/typography";

.grid {
  display: inline-grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  grid-gap: 14px;
  width: 100%;
}

.button {
  white-space: nowrap;
}

